import React from 'react';
import type { TrustItem } from '../../types/pricing';
type TrustStripProps = {
  items: TrustItem[];
};
export function TrustStrip({
  items
}: TrustStripProps) {
  return <ul className="mt-10 grid grid-cols-1 gap-4 border-t border-canvas-line pt-8 sm:grid-cols-2 lg:grid-cols-4" data-id="element-1023" data-mp="29s1uwzcx69v">
      {items.map(item => {
      const Icon = item.icon;
      return <li key={item.label} className="flex items-center justify-center gap-2.5 text-[14px] font-medium text-ink-soft sm:justify-start lg:justify-center" data-id="element-1024" data-mp="7aoeq01os2rf">
            <Icon className="h-[18px] w-[18px] shrink-0 text-brand" strokeWidth={1.9} aria-hidden="true" data-id="element-1025" data-mp="zw7lo5f9ag0l" />
            {item.label}
          </li>;
    })}
    </ul>;
}